import { mapGetters } from 'vuex'

const fixWH = {
	computed: {
		...mapGetters('examination/configation', ['tempImgZoomRate']),
		concludeWH() {
			return {
				width: `${this.tempImgZoomRate.pageWidth}px`,
				height: `${this.tempImgZoomRate.pageHeight}px`
			}
		}
	},
	methods: {
		//检查宽度
		operateWidth(rectItem) {
			if (rectItem.areaMaxX - rectItem.areaMinX <= 0) return 1
			return rectItem.areaMaxX - rectItem.areaMinX
		},
		//检查高度
		operateHeight(rectItem) {
			if (rectItem.areaMaxY - rectItem.areaMinY <= 0) return 1
			return rectItem.areaMaxY - rectItem.areaMinY
		}
	}
}
export default fixWH
